import { useCurrentAccountId } from "@zapier/identity";

import { useCurrentUser } from "../user/useCurrentUser";

import useAdminApprovalRule from "./useAdminApprovalRule";

export const useCanApprove = () => {
  const currentAccountId = useCurrentAccountId();
  const { user, isLoading: isLoadingUser } = useCurrentUser();

  const { canAdminApprove, isLoading: isLoadingAdminApprovalRule } =
    useAdminApprovalRule({ enabled: true });

  if (!user) {
    return {
      canApprove: false,
      isLoading: isLoadingUser || isLoadingAdminApprovalRule,
    };
  }

  const accountRole = user.roles?.find(
    (role: { accountId: number; role: string }) =>
      role.accountId === currentAccountId,
  );

  const baseRoles = ["owner", "super_admin"];
  const allowedRoles = canAdminApprove ? [...baseRoles, "admin"] : baseRoles;

  return {
    canApprove: accountRole?.role
      ? allowedRoles.includes(accountRole.role)
      : false,
    isLoading: isLoadingUser || isLoadingAdminApprovalRule,
  };
};
